<template>
  <div class="calculator">
    <h1>{{ $t("title") }}</h1>
    <p>{{ $t("subtitle") }}</p>

    <ArticleSearch v-if="showArticleSearch" @search-article="handleArticleNumberChange" />

    <RoomTypes :preselectedRoomType="getPreselectedRoomType" :types="roomTypes" @select-roomtype="roomTypeSelected"></RoomTypes>

    <div :class="[isReadyForEnteringData + ' flex']">
      <div class="flex__item">
        <h3>{{ $t("roomType") }}</h3>
        <RoomImage :dimensions="roomDimensions" :circleRadius="10"></RoomImage>
      </div>

      <div class="flex__item">
        <RoomMeasures @measurement-change="handleRoomMeasurement"></RoomMeasures>
      </div>

      <div class="flex__item">
        <Lightning
          :key="luxKey"
          :initialLux="lux"
          :dimensions="roomDimensions"
          @lighting-change="handleLightingChange"
          @render-result="renderResult"
          @clear-result="clearResult"
          :class="isReadyForEnteringData"
        ></Lightning>
      </div>
    </div>
    <!-- /.flex -->
    <div class="result" v-if="result">
      <p class="result__text">{{ $t("resultText", { lamps: leuchten, lux: resultLux }) }}</p>
      <a class="btn btn-primary btn-inverted" :href="resultPdf">
        {{
        $t("showPDF")
        }}
      </a>
    </div>
    <a id="resultAnchor" name="resultAnchor"></a>

    <div v-if="isLoading" class="loadingscreen absolute">
      <h2>{{ $t("isLoading") }}</h2>
    </div>
  </div>
</template>

<script>
import ArticleSearch from "@/components/ArticleSearch.vue";
import RoomTypes from "@/components/RoomTypes.vue";
import RoomMeasures from "@/components/RoomMeasures.vue";
import Lightning from "@/components/Lightning.vue";
import RoomImage from "@/components/RoomImage.vue";
import VueScrollTo from "vue-scrollto";
import FdConfig from "@/../fd.config";

export default {
  props: {
    rows: {
      type: Number,
      default: 0
    },
    cols: {
      type: Number,
      default: 0
    },
    currentArticleNumber: {
      //holds the articleNumber when called under an article? (check this.$store for the articleNumber)
      type: String
    }
  },
  methods: {
    handleArticleNumberChange(artNr) {
      this.$store.dispatch("setArticleNumber", artNr);
    },
    roomTypeSelected(roomId) {
      let currentRoomType = this.roomTypes.filter(room => {
        return room.id === roomId;
      })[0];
      this.selectedRoomType = currentRoomType;
      this.lux = currentRoomType.defaultLux;
      this.initialLux = currentRoomType.defaultLux;
      this.luxKey++; //required to trigger redraw ot the Lightning component
      this.$store.dispatch("setRoomType", currentRoomType);
    },
    handleRoomMeasurement(roomMeasurement) {
      this.roomDimensions.roomlength = roomMeasurement.roomlength;
      this.roomDimensions.height = roomMeasurement.height;
      this.roomDimensions.width = roomMeasurement.width;
      // console.log(
      //   "handleRoomMeasurementChange() called with: ",
      //   roomMeasurement
      // );
    },
    handleLightingChange(data) {
      this.roomDimensions.lampData.rows = data.reihen || this.rows;
      this.roomDimensions.lampData.columns = data.spalten || this.cols;
      // console.log(
      //   "handleLightingChange() called with: ",
      //   data,
      //   this.roomDimensions
      // );
    },
    renderResult(data) {
      // console.log("renderResult", data);
      if (data) {
        this.result = data;
        this.leuchten = data.leuchten;
        this.resultLux = data.lux;
        this.resultPdf = data.pdf;

        var options = {
          // container: "#app",
          easing: "ease-in",
          offset: -60,
          force: true,
          cancelable: true,
          //eslint-disable-next-line
          onStart: function(element) {
            // scrolling started
            // console.log("Scrolling started: ", element);
          },
          //eslint-disable-next-line
          onDone: function(element) {
            // scrolling is done
            // console.log("Scrolling ended: ", element);
          },
          onCancel: function() {
            // scrolling has been interrupted
            // console.log("Scrolling cancelled.");
          },
          x: false,
          y: true
        };
        let element = document.getElementById("resultAnchor");
        VueScrollTo.scrollTo(
          element,
          FdConfig.scrollToResultDuration || 1000,
          options
        );
      }
    },
    clearResult() {
      this.result = null;
      this.resultLux = null;
      this.resultPdf = "";
    }
  },
  components: {
    ArticleSearch,
    RoomTypes,
    RoomMeasures,
    Lightning,
    RoomImage
  },
  data() {
    return {
      selectedRoomType: null,
      leuchten: 0,
      result: null,
      isLoading: false,
      luxKey: 0,
      lux: 19, //some default value to pass to the <Lighting> component?
      resultLux: 0,
      resultPdf: "",
      roomDimensions: {
        width: 0, //x-axis
        height: 0, //unused for svg
        roomlength: 0, //y-axis
        lampData: {
          //amount of circles, leuchten must match rows*columns
          rows: this.rows,
          columns: this.cols
        }
      },
      roomTypes: FdConfig.roomTypes
    };
  },
  computed: {
    isReadyForEnteringData() {
      let articleNumber = this.$store.getters.getArticleNumber;
      // console.log("isReadyForEnteringData: ", articleNumber);
      return this.roomDimensions.roomlength > 0 &&
        this.roomDimensions.width > 0 &&
        this.roomDimensions.height > 0 &&
        articleNumber &&
        articleNumber.length > 2 //maybe that check is not enough, but there will be no article with a fewer characters
        ? "isready"
        : "notready";
    },
    showArticleSearch() {
      return !this.$store.getters.getArticleSearchFormVisibility;
    },
    getPreselectedRoomType() {
      let initialRoomType = this.$store.getters.getSelectedRoom;
      // console.log("getPreselectedRoomType: ", initialRoomType);
      return (typeof initialRoomType === 'string' || initialRoomType instanceof String) ? initialRoomType : null ;
    }
  },
  mounted() {
    this.$store.subscribe(mutation => {
      if ("SET_LOADING_SCREEN" == mutation.type) {
        this.isLoading = mutation.payload;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/include-media.scss";
@import "@/assets/scss/_variables.scss";
.flex {
  display: flex;
  justify-content: space-between;
  &__item {
    width: 36%;
    padding: 1%;
    border: 1px solid silver;
    &:nth-child(2) {
      width: 24%;
    }
  }
  @include media("<desktop-s") {
    justify-content: space-around;
    flex-wrap: wrap;
    &__item {
      margin-bottom: 1em;
      &:nth-child(1) {
        order: 3;
        width: 100%;
      }
      &:nth-child(2) {
        order: 1;
        width: 49%;
      }
      &:nth-child(3) {
        order: 2;
        width: 49%;
      }
    }
  }
  @include media("<tablet-m") {
    &__item {
      &:nth-child(n) {
        width: 100%;
      }
    }
  }
}
.result {
  background-color: black;
  color: white;
  padding: 20px;
  margin-top: 2rem;
  &__text {
    margin-bottom: 1em;
  }
}
.btn-inverted {
  filter: invert(1);
}

.loadingscreen {
  top: 0;
  left: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1337;
  h2 {
    color: #fff;
    margin-top: 50%;
    transform: translateY(-50%);
    height: 100vh;
  }
}
</style>
